export const DEFAULT_LATITUDE = -1.2044975;
export const DEFAULT_LONGITUDE = 36.7752525;
